import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { withNamespaces } from "react-i18next";

import Card from "ati-ui-react/components/Card";
import RouteWithoutRestrictions from "../RouteWithoutRestrictions";
import FilterPanel from "../FilterPanel";
import RouteSummary from "../RouteSummary";
import RouteStatistics from "../RouteStatistics";
import FindButtonsPanel from "../FindButtonsPanel";
import Route from "../Route";
import Footer from "../Footer";
import SeoText from "../SeoText";
import ToggleRouteStatisticsPanelButton from "../ToggleRouteStatisticsPanelButton";
import Banner from "../Banner";

import styles from "./Sidebar.scss";

class Sidebar extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { showResults, routeWithoutRestrictions } = this.props;

    if (nextProps.showResults !== showResults) {
      this.scrollTop = true;
    }
    if (nextProps.routeWithoutRestrictions !== routeWithoutRestrictions || this.routeWithoutRestrictionsProcessed) {
      this.scrollToWithoutRestrictions = true;
    }
    this.routeWithoutRestrictionsProcessed = false;
  }

  componentDidUpdate() {
    const { showResults, routeWithoutRestrictions } = this.props;
    if (showResults && !!this.scrollTop) {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;
      this.scrollTop = false;
    }
    if (showResults && routeWithoutRestrictions && !this.routeWithoutRestrictionsProcessed && !!this.scrollToWithoutRestrictions && this.RouteWithoutRestrictionsBlock) {
      if (!this.isElementInViewport(this.RouteWithoutRestrictionsBlock)) {
        this.RouteWithoutRestrictionsBlock.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      this.scrollToWithoutRestrictions = false;
      this.routeWithoutRestrictionsProcessed = true;
    }
  }

  isElementInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }


  render() {
    const { showResults, sidebarToggled, routeWithoutRestrictions } = this.props;

    return (
      <div className={styles.sidebarWrapper}>
        {showResults && <RouteSummary />}
        <Card
          className={classnames(styles.sidebar, {
            [styles.searchResultsSidebar]: showResults,
            [styles.filterSidebar]: !showResults,
            [styles.taped]: sidebarToggled,
          })}
        >
          {!showResults && <FilterPanel />}
          {showResults && <RouteStatistics />}
          {routeWithoutRestrictions && (
            <RouteWithoutRestrictions containerRef={el => {
              this.RouteWithoutRestrictionsBlock = el;
              if (this.RouteWithoutRestrictionsBlock) {
                if (!this.isElementInViewport(this.RouteWithoutRestrictionsBlock)) {
                  this.RouteWithoutRestrictionsBlock.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                  });
                }
              }
            }} />
          )}
          <div
            id="docRoute300x100"
            className={classnames(styles.doc300x100, {
              [styles.hideOnMapTap]: sidebarToggled,
            })}
          >
            <Banner bannerSizeId={16} />
          </div>

          {showResults && (
            <React.Fragment>
              <FindButtonsPanel className={styles.hideOnMapTap} />
              <Route className={styles.hideOnMapTap} />
              <SeoText className={styles.hideOnMapTap} />
            </React.Fragment>
          )}
          <Footer className={styles.hideOnMapTap} />
          {sidebarToggled && <ToggleRouteStatisticsPanelButton />}
        </Card>
      </div>
    );
  }
}

Sidebar.propTypes = {
  showResults: PropTypes.bool.isRequired,
  sidebarToggled: PropTypes.bool.isRequired,
  routeWithoutRestrictions: PropTypes.bool.isRequired
};

export default withNamespaces()(Sidebar);
